export default {
  bad_connection: 'ups, ada yang salah. Silakan periksa koneksi jaringan Anda lalu coba lagi',
  send: 'Mengirim',
  select_hotel: 'Silakan pilih hotel tempat Anda menginap',
  select_language: 'Silakan pilih bahasa Anda.',
  start_chatting: 'Mulai Mengobrol',
  languages: 'Bahasa',
  menu: 'Menu',
  close: 'Menutup',
  back: 'Kembali',
  next: 'Berikutnya',
  message: 'Silakan ajukan pertanyaan',
  search: 'Mencari',
  select: 'Pilih',
  sign_in: 'Masuk',
  sign_out: 'Keluar',
  sign_up: 'Mendaftar',
  smoking: 'Merokok',
  no_smoking: 'Bebas Rokok',
  adults: 'Dewasa',
  xAdults: 'Dewasa',
  children: 'Anak',
  ageOfChild: 'Usia anak',
  seeAll: 'Lihat semua',
  email: 'Surel',
  email_confirmation: 'Email (untuk konfirmasi)',
  phone_number: 'Nomor telepon',
  icc: 'ICC',
  month: 'Bulan',
  year: 'Tahun',
  including_taxes: 'termasuk pajak',
  excluding_taxes: 'tidak termasuk pajak',
  show_more: 'Menampilkan lebih banyak',
  show_less: 'Tampilkan lebih sedikit',
  file_upload: {
    unsupported_file_type: 'Maaf, kami tidak mendukung file dengan tipe {file_type}',
    file_size_exceeded: 'File melebihi batas ukuran 10MB',
    file_upload_failed: 'Gagal mengunggah file',
    max_files_upload_simultaneously: 'Maksimal 5 file dapat diunggah secara bersamaan'
  },
  base: {
    back_to_list: 'kembali ke daftar',
    pay: 'Membayar',
    cancel: 'Membatalkan',
    delete: 'Menghapus',
    yes: 'Ya',
    no: 'TIDAK',
    book: 'Buku',
    direct_price: 'Harga Langsung',
    membership_rate: 'Tingkat Keanggotaan',
    regular_rate: 'Tarif Reguler',
    expand_for_price: 'Perluas untuk membandingkan',
    confirmSelection: 'Konfirmasikan pilihan',
    neverAskAgain: 'Jangan bertanya lagi',
    accept: 'Menerima',
    do_not_accept: 'Jangan terima',
    password: 'Kata sandi',
    email: 'Surel',
    save: 'Menyimpan',
    confirm_password: 'Konfirmasi sandi',
    error02: 'Terjadi kesalahan selama pemrosesan. Silakan coba lagi nanti.',
    errorCode: {
      3001: 'Terjadi kesalahan batas waktu. Pembayaran belum diproses.',
      3002: 'Proses pembayaran gagal.',
      3003: 'Kartu ini tidak tersedia.',
      3004: 'Harap konfirmasi nomor kartu.',
      3005: 'Harap pastikan tanggal kedaluwarsa Anda sudah benar.',
      3006: 'Otentikasi 3D Secure gagal.',
      3007: 'Kartu kredit tidak diterima atau nomor kartu salah.',
      3008: 'Otentikasi 3D Secure telah dibatalkan.',
      3009: 'Otentikasi 3D Secure telah ditangguhkan karena beberapa permintaan.',
      3011: 'Terjadi kesalahan batas waktu. Pembayaran belum diproses.',
      3203: 'Terjadi kesalahan selama pemrosesan. Silakan coba lagi nanti.',
      3204: 'Proses pembayaran gagal, Silakan gunakan kartu lain, atau coba lagi nanti.',
      3205: 'Kartu ini tidak tersedia.'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: 'Mohon tinjau kembali informasi yang Anda berikan.',
    INVALID_EXPIRATION_YEAR: 'Harap pastikan tanggal kedaluwarsa Anda sudah benar.',
    Invalid_card_number: 'Harap konfirmasi nomor kartu.',
    Others: 'Mohon tinjau kembali informasi yang Anda berikan.'
  },
  validation: {
    is_required: '{bidang} wajib diisi',
    correct_email: 'Silakan masukkan alamat email yang benar',
    invalid_integer: 'Silakan masukkan bilangan bulat'
  },
  chat_body: {
    deleted_message: 'Anda menghapus pesan ini',
    op_deleted_msg: 'Operator menghapus pesan ini',
    delete_message: 'Hapus pesan',
    delete_message_desc: 'Apakah Anda yakin ingin menghapus pesan ini? Ini tidak dapat dibatalkan'
  },
  user_top: {
    information:
      'Jika Anda ingin melanjutkan ngobrol dengan kami di perangkat lain, silakan mendaftar. Anda dapat mengambil pesan Anda di perangkat apa pun saat Anda masuk.',
    terms_and_condition: {
      before: 'Dengan mendaftar, saya setuju',
      link: 'Syarat dan Ketentuan',
      and: 'Dan',
      privacy_policy: 'Kebijakan pribadi',
      after: '.'
    },
    sign_in_with_facebook: 'Masuk dengan Facebook',
    sign_out_with_facebook: 'Keluar dari Facebook di perangkat ini',
    sign_in_with_line: 'Masuk dengan LINE',
    sign_in_with_weibo: 'Masuk dengan Weibo',
    create_account: 'Buat Akun',
    or: 'atau',
    already_have_an_account: 'Sudah memiliki akun?',
    sign_in_with_email: 'Masuk dengan Email',
    forgot_password: 'Tidak ingat kata sandi?'
  },
  new_user: {
    information: 'Silakan masukkan nama dan alamat email Anda dan tekan Daftar.',
    information2: 'Anda akan menerima verifikasi dari chatbot@tripla.jp',
    first_name: 'Nama depan',
    last_name: 'nama keluarga',
    name_placeholder: 'Namamu',
    email_placeholder: 'Alamat email',
    submit: 'Mendaftar',
    email_sent:
      'Tautan verifikasi telah dikirim ke alamat email Anda. Silakan klik link yang baru saja dikirimkan dan {sign in}',
    error_message: {
      problem:
        'Ada masalah saat membuat akun Anda. Silakan periksa alamat email Anda dan coba lagi.',
      email: 'Email tidak valid atau sudah dipakai'
    }
  },
  new_session: {
    information: 'Silakan masukkan alamat email dan kata sandi Anda dan tekan Masuk',
    email_placeholder: 'Alamat email',
    password_placeholder: 'Kata sandi',
    submit: 'Masuk/Pendaftaran Keanggotaan',
    error_message: {
      email: 'Maaf, email atau kata sandi Anda mungkin salah',
      known_user_different: 'Pengguna yang dikenal berbeda'
    }
  },
  destroy_session: {
    information:
      'Apakah Anda ingin keluar? Anda harus masuk kembali jika ingin menampilkan pesan yang ada.',
    submit: 'Keluar'
  },
  forgotten_password: {
    information:
      'Silakan masukkan alamat email Anda. Kami akan mengirimkan konfirmasi ke akun email Anda.',
    email_placeholder: 'Alamat email',
    submit: 'Mengirim',
    error: 'Tidak dapat menyetel ulang sandi'
  },
  forgotten_password_confirmation: {
    information:
      'Anda akan menerima email berisi petunjuk tentang cara mengatur ulang kata sandi Anda dalam beberapa menit.'
  },
  reset_password: {
    title: 'Ganti kata sandi',
    password_title: 'Kata sandi',
    password_hint: 'minimal 8 karakter',
    password_confirmation_title: 'Konfirmasi password)',
    submit: 'Ganti kata sandi'
  },
  set_reset_password: {
    title: 'Ganti kata sandi',
    information: 'Kata sandi Anda telah disetel ulang.',
    information2: 'Silakan kembali ke tempat Anda mengatur ulang kata sandi dan masuk lagi.'
  },
  menu_items: {
    1: 'Periksa ketersediaan kamar',
    2: 'Reservasi kamar',
    3: 'Konfirmasi reservasi kamar'
  },
  modal: {
    back_to_chat: 'Kembali ke obrolan'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'MasterCard',
    mastercard: 'MasterCard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Klub Pengunjung'
  },
  credit_card: {
    error: {
      cvv: 'Pastikan CVV Anda benar',
      expiration: 'Harap pastikan tanggal kedaluwarsa Anda sudah benar',
      name: 'Pastikan nama pemegang kartu sudah benar',
      number: 'Silakan gunakan nomor kartu kredit yang valid',
      unknown:
        'Ada masalah saat memproses permintaan Anda, pastikan informasi yang Anda berikan sudah benar',
      reservation_month:
        'Harap pastikan tanggal habis masa berlaku kartu kredit setidaknya tersisa satu bulan setelah tanggal pemesanan.'
    },
    accept: 'Kami menerima:',
    cvv: 'CVV',
    expiration: 'Tanggal habis tempo',
    intro: 'Silakan masukkan informasi yang diperlukan untuk kartu yang ingin Anda gunakan',
    name: 'Nama pemegang kartu',
    number: 'Nomor kartu',
    save: 'Simpan Kartu Ini',
    submit: 'Tambahkan kartu',
    title: 'Tambahkan Kartu Kredit Baru',
    security_code: 'Kode keamanan',
    card_holder_confirm: 'Harap konfirmasi nama pemegang kartu',
    card_holder_format_confirm: 'Silakan masukkan nama Anda dalam karakter Romawi setengah lebar.',
    expiration_confirm: 'Harap konfirmasi tanggal kedaluwarsa',
    card_cvv_confirm: 'Harap konfirmasi kode keamanan',
    card_number_confirm: 'Harap konfirmasi nomor kartu',
    card_brand: 'Tipe kartu',
    select_card_brand: 'Pilih jenis kartu'
  },
  payment: {
    total: 'Total'
  },
  currencies: {
    JPY: 'Yen'
  },
  chat_channels: {
    title: 'Silakan pilih saluran',
    facebook: 'Kurir',
    web: 'jaring',
    line: 'GARIS',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: 'Permintaan',
    request: 'Meminta',
    status: 'Status',
    no_data: 'Saat ini Anda tidak memiliki permintaan',
    payment: 'Pembayaran',
    customer: 'Pelanggan',
    phone: 'Telepon',
    people: 'Rakyat',
    facility_name: 'Nama fasilitas',
    requested_day: 'Hari yang diminta',
    requested_time: 'Waktu yang diminta',
    confirm_cancel_msg:
      'Harap konfirmasikan bahwa Anda ingin membatalkan permintaan ini. Kami akan mengirimkan pemberitahuan kepada pengelola dan setelah pembatalan selesai, Anda akan menerima konfirmasi.',
    cancel_request: 'Batalkan permintaan',
    edit_request: 'Sunting Permintaan',
    keep_request: 'Simpan Permintaan'
  },
  requests: {
    statuses: {
      _destroyed: 'Hancur',
      cancel_requested: 'Pembatalan diminta',
      cancelled: 'Dibatalkan',
      change_requested: 'Pembaruan diminta',
      created: 'Dibuat',
      departure_unconfirmed: 'Keberangkatan belum dikonfirmasi',
      done: 'Selesai',
      in_progress: 'Sedang berlangsung',
      no_show: 'Tidak ada pertunjukan',
      stopped: 'Berhenti',
      wait_listed: 'Tunggu terdaftar',
      waiting_detail: 'Detilnya menunggu'
    }
  },
  best_rate: 'HARGA TERBAIK',
  time_picker: {
    AM: 'SAYA',
    PM: 'PM'
  },
  details_page: {
    details: 'Keterangan lebih lanjut'
  },
  date_range: {
    select: 'Pilih tanggal masa inap Anda',
    send: 'Klik pilih untuk melanjutkan',
    no_disabled_dates:
      'Anda tidak dapat memasukkan tanggal tidak tersedia. Silakan pilih rentang tanggal yang benar'
  },
  facebook: {
    email_sent:
      'Tautan verifikasi telah dikirim ke alamat email Anda. Silakan klik tautan untuk mengonfirmasi dan melanjutkan',
    no_email:
      'Silakan berikan alamat email Anda. Kami akan mengirimkan konfirmasi reservasi kepada Anda setelah reservasi dilakukan.',
    signInFailed: 'Gagal masuk, silakan coba lagi',
    sign_out: 'Silakan klik tombol di bawah ini untuk keluar dari Facebook.'
  },
  confirm_form: {
    search: 'Mencari lagi',
    update_contact: 'Perbarui Info Kontak'
  },
  contact_form: {
    update: 'Memperbarui',
    submit: 'Kirim',
    full_name: 'Nama lengkap',
    family_name: 'Nama keluarga',
    first_name: 'Nama depan',
    cc_email: 'cc email ke...',
    error: {
      full_name_error: 'Harap berikan nama lengkap dalam bahasa Inggris',
      tel_format_error: 'Angka, spasi, +, dan () dapat digunakan sebagai nomor telepon.',
      tel_length_error: 'Silakan masukkan nomor telepon yang lebih dari 9 digit.',
      email_format_error: 'Harap berikan alamat email yang valid (mis. nama@gmail.com)',
      email_confirmation_error: 'alamat email tidak sama'
    }
  },
  room_not_available:
    'Maaf, kami tidak memiliki kamar yang tersedia untuk tanggal yang Anda pilih.',
  search_again: 'Mencari lagi',
  room_not_available_short: 'Tidak tersedia.',
  email_form: {
    note_placeholder: 'Silakan masukkan rincian mengenai permintaan Anda'
  },
  rental_car_form: {
    pickup_title: 'Toko penjemputan',
    pickup_area: 'Pemilihan wilayah',
    pickup_shop: 'Pilihan toko',
    pickup_date_time: 'Tanggal penjemputan',
    return_title: 'Kembalikan toko',
    return_area: 'Pemilihan wilayah',
    return_shop: 'Pilihan toko',
    return_date_time: 'Tanggal pengembalian',
    back: 'Kembali'
  },
  search_area_form: {
    select_prefecture_area: 'Silakan pilih prefektur dan wilayah',
    prefecture: 'Prefektur',
    area: 'Daerah'
  },
  restaurant_form: {
    breakfast: 'Sarapan',
    lunch: 'Makan siang',
    dinner: 'Makan malam',
    main_time: 'Waktu utama',
    alternative_times: 'Waktu alternatif',
    pick_multiple: 'Silakan pilih beberapa. Kami menyarankan 3',
    any_available_time: 'Kapan saja waktu yang tersedia'
  },
  terms_of_use: 'Syarat Penggunaan',
  privacy_policy: 'Kebijakan pribadi',
  browser_warning:
    'Browser web Anda sudah kedaluwarsa. Harap perbarui untuk keamanan, kecepatan, dan pengalaman yang lebih baik di situs ini.',
  for_night: 'untuk {n} malam | untuk {n} malam | selama {n} malam',
  chat_icon: {
    chat: 'Mengobrol'
  },
  chat_evaluation: {
    title: 'Kepuasan pelanggan',
    msg:
      'Harap luangkan waktu sejenak untuk memberi tahu kami apakah Anda puas dengan chatbot kami atau tidak',
    not_satisfied: 'Tidak puas',
    satisfied: 'Puas'
  },
  cookie_consent: {
    title: 'Kelola Persetujuan Cookie',
    necessary: 'Diperlukan: Riwayat obrolan dan status login',
    functional:
      'Fungsional: Cookie ini menyimpan preferensi Anda seperti kebijakan privasi dan tata letak chatbot',
    performance:
      'Kinerja: Cookie ini membantu kami menghitung kunjungan dan klik pengguna untuk membantu kami meningkatkan layanan kami',
    advertising:
      'Penargetan dan periklanan: Cookie ini membuat pesan iklan lebih relevan bagi Anda',
    accept_all: 'Terima semua',
    confirm: 'Konfirmasikan pilihan saya',
    cookies_accepted: 'Cookie diterima'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
